    
    <div class='content-wrapper'>
        <div class="continerTabs">
            <button (click)="loginBySms()" class="tab" role="tab"  [ngClass]='{activeTab:tabIndex==1 ||tabIndex==3 }' aria-selected="true"
            aria-controls="loginViaSms" id="tab-1">
                <span>כניסה עם <br>
                     קוד חד פעמי לנייד</span>
            </button>
            <button (click)="loginByPassword()" role="tab" class="tab" [ngClass]='{activeTab:tabIndex==2}'  aria-selected="false"
            aria-controls="loginViaPassword" id="tab-2">
                <span>כניסה עם  <br>
                     קוד משתמש וסיסמה</span>
            </button>
        </div>
        <div *ngIf="tabIndex==1" id="loginViaSms" role="tabpanel" aria-labelledby="tab-1">
            <app-login-via-sms (loginViaPassword)="loginByPassword()" (sendOtp)="sendOtp($event)"></app-login-via-sms>
        </div>
        <div *ngIf="tabIndex==3">
            <app-login-via-otp [otp]="mobile"></app-login-via-otp>
        </div>

        <div *ngIf="tabIndex==2" id="loginViaPassword" role="tabpanel" aria-labelledby="tab-2">
            <app-login-via-password></app-login-via-password>
        </div>
    </div>
 
